export const getFrontendRedirectBaseUrl = () => {
  // Assumes that during local development, frontend is running locally
  // on port 3001, while account portal is running on port 3000
  if (window.location.origin.includes('localhost'))
    return 'http://localhost:3001'
  const baseurl = window.IRISVR_ENV.base_url
  return baseurl.replace('api.', '').replace('/v3', '')
}
